import useLeserreporterContext from '@hooks/useLeserreporterContext'
import { ChangeEvent, FunctionComponent } from 'react'
import styled, { css } from 'styled-components'

const StyledBulletpointChoices = styled.div`
  ${({
    theme: {
      colors: { strokeWeak },
    },
  }) => css`
    display: flex;
    flex-direction: column;

    :not(:last-child) {
      border-bottom: 1px solid ${strokeWeak};
    }
  `}
`

const StyledLabel = styled.label`
  ${({
    theme: {
      typography: {
        bodycopy: {
          small2: { bundledCSS: bodyCopySmall2CSS },
        },
      },
      spacing: { spacing2, spacing8, spacing4, spacing16, spacing20 },
      colors: { staticRed500, fillDefault, strokeStrong },
    },
  }) => css`
    padding: ${spacing16} 0;
    ${bodyCopySmall2CSS};
    display: flex;
    gap: ${spacing8};
    align-items: center;

    input[type='radio'] {
      appearance: none;
      -webkit-appearance: none; /*value*/ /*for Safari and Chrome */
      -moz-appearance: none;
      min-width: ${spacing20};
      width: ${spacing20};
      height: ${spacing20};
      border-radius: 50%;
      border: ${spacing4} solid ${fillDefault};
      box-shadow: 0 0 0 ${spacing2} ${strokeStrong};
      margin-bottom: ${spacing2};

      &:checked {
        background-color: ${staticRed500};
        box-shadow: 0 0 0 ${spacing2} ${staticRed500};
      }
    }
  `}
`

const BulletpointChoices: FunctionComponent = () => {
  const {
    data: { category },
    handleChange,
  } = useLeserreporterContext()

  return (
    <StyledBulletpointChoices
      onChange={handleChange as (event: ChangeEvent<HTMLInputElement>) => void}>
      <StyledLabel>
        <input
          type="radio"
          value="news"
          name="category"
          defaultChecked={category === 'news'}
        />
        Ich möchte ein Leserreporter-Foto oder -Video schicken.
      </StyledLabel>
      <StyledLabel>
        <input
          type="radio"
          value="community"
          name="category"
          defaultChecked={category === 'community'}
        />
        Ich antworte auf einen Community-Aufruf.
      </StyledLabel>
      <StyledLabel>
        <input
          type="radio"
          value="tip"
          name="category"
          defaultChecked={category === 'tip'}
        />
        Ich habe spannende Infos für eine Story.
      </StyledLabel>
    </StyledBulletpointChoices>
  )
}

export default BulletpointChoices
